var styles = {"close":"styles_close__Y_bEz","dialog":"styles_dialog__3V-SH","background":"styles_background__4Eoas","picture3x2":"styles_picture3x2__3wMx9","closed":"styles_closed__wyU9z","spinAround":"styles_spinAround__1tzvY"};

export { styles as default };
//# sourceMappingURL=styles.scss.js.map
